var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[(_vm.error)?_c('div',{staticClass:"root lx-validation-error",class:{ static: _vm.static }},[_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.error))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }